import request from "project-config/services/request/request";
import { message } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useProjectStore } from "../../../store/project-store";

export function useStatus() {
  const { fetchProjectData } = useProjectStore();
  const t = getTranslateNsT("center");
  async function changeProjectStatus(projectId: number, status: number) {
    const res = await request.post(
      "/api/rendering/task/common/updateLabelStatus",
      {
        projectId,
        status: Number(!Boolean(status)),
      }
    );
    if (res.code === 605) {
      message.error(
        t("user_com_childPro_render_btn_vinsufficient_permissions")
      );
      return;
    }
    if (res.code === 200) fetchProjectData();
  }
  return {
    changeProjectStatus,
  };
}
